import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client"
import fetch from "cross-fetch"
import { backendPoint } from "../config"

const httpLink = createHttpLink({
  uri: backendPoint,
  fetch,
})

const client = new ApolloClient({
  link: httpLink,
  cache: new InMemoryCache(),
})

export default client
